import { Component } from '@angular/core';
import { login } from 'src/app/Models/login';
import { update } from 'src/app/Models/update';
import { UserItem } from 'src/app/Models/Users';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { UsersService } from 'src/app/Services/users.service';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.css']
})
export class SecurityComponent {

shownewpass:boolean=false
showsuccess:boolean=false
currentpass:boolean=true
confirmpass:string=''
oldpass:string=''
currentpasserror:string=''
oldnewpassverifyerror:string=''

loginuser: Partial<login> = {};
user: Partial<UserItem> = {};
updatepass:update=
{
  userId:0,
  password:'',
  success:false
}
userid:number=0

 storedDataa: UserItem | null = null;


constructor(private authservice:AuthenticationService){}



ngOnInit(): void {
    const storedData = sessionStorage.getItem('userData');
 if (storedData) {
  const parsedData = JSON.parse(storedData);
  this.userid  = parsedData.userId;


  }}



newpassword() {
  debugger
  
this.updatepass.userId=this.userid
  this.authservice.updatePassword(this.updatepass).subscribe((res)=>{

if(res.success)

  {
    this.oldpass=this.updatepass.password
 this.shownewpass = true;
      this.currentpass = false;
      
  }
 
else
{
  this.currentpasserror='Current Password Is Incorrect'
}}

)}
      
    

    oldnewerror() {
  if (this.oldnewpassverifyerror) {
    this.oldnewpassverifyerror = '';
  }

  
}
 clearCurrentPassError() {
  if (this.currentpasserror) {
    this.currentpasserror = '';
  }

  
}
   

showsucessfun()
{debugger
  if( this.oldpass!=this.updatepass.password)
    {
    if(this.updatepass.password==this.confirmpass)
   {
  this.updatepass.userId=this.userid
  this.authservice.newUpdatepass(this.updatepass).subscribe((res)=>{

this.showsuccess=true
  this.currentpass=false
  this.shownewpass=false
  })
}
  }
  else{
this.oldnewpassverifyerror='Enter New Password'
  }
  
}

falseall()
{
  this.shownewpass=false
this.showsuccess=false
this.currentpass=true
}




}
